import { apiCallable } from '@src/util/cloud-functions/apiClient';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

class SignUpRepository {
  async updateSignUp(data) {
    const signUpUpdateFn = apiCallable(API_OPERATIONS.SIGN_UP_UPDATE);
    const response = await signUpUpdateFn(data);
    return response.data;
  }
}

export default SignUpRepository;
